import type { Texture } from "@luma.gl/core"

export type FrameImage = { bitmap: ImageBitmap; width: number; height: number }

export class FrameTextureCache {
    private readonly entries = new Map<ImageBitmap, Texture>()

    constructor(private readonly capacity = 3) {}

    get(image: FrameImage, create: (image: FrameImage) => Texture) {
        const hit = this.entries.get(image.bitmap)
        if (hit) {
            this.entries.delete(image.bitmap)
            this.entries.set(image.bitmap, hit)
            return hit
        }
        const texture = create(image)
        this.entries.set(image.bitmap, texture)
        while (this.entries.size > this.capacity) {
            const oldest = this.entries.keys().next().value
            if (oldest === undefined) break
            this.entries.get(oldest)?.destroy()
            this.entries.delete(oldest)
        }
        return texture
    }

    destroy(): void {
        for (const texture of this.entries.values()) texture.destroy()
        this.entries.clear()
    }
}
